import Head from 'next/head'

/**
 * Renders a schema.org JSON-LD block into <head>.
 * `id` must be unique per page; next/head dedupes by key, so two blocks
 * with the same id would collapse into one.
 */
export default function JsonLd({
  id,
  data,
}: {
  id: string
  data: Record<string, unknown>
}) {
  return (
    <Head>
      <script
        key={`jsonld-${id}`}
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({ '@context': 'https://schema.org', ...data }),
        }}
      />
    </Head>
  )
}
